import $ from "jquery";
window.jQuery = window.$ = $;
import bootstrap from "bootstrap";
import device from "current-device";
import slick from "slick-carousel";

require("./app");
